module Meevo.Plugins.Resources {
    "use strict";

    export class ResourcesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        public maxResourceUnitsPerResource: number = 0;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.baseEndpoint = appSettings.API_ENDPOINTS.resource;
            this.sectionTemplatePath = "app/plugins/resources/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.DATA_RESOURCE_TAB_MAIN);
            this.entityType = 'Resource';
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_RESOURCE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_RESOURCES_MAIN",
                    "main.html",
                    true, 
                    false, 
                    this.baseEndpoint, 
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.ResourceMain,
                    this.modalService,
                    this.securityKeys.DATA_RESOURCE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }

            this.dataService.customMethodData("api/Settings/General", "get", {}).then((data) => {
                this.maxResourceUnitsPerResource = data.data.maxResourceUnitsPerResource;
            });
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.Resource>();
            model.displayName = undefined;
            model.shortcut = undefined;
            model.canBeSplit = undefined;
        }

        isCategoryOwning(_model) {
            return _model && _model.homeLocationId != this.selectedSection.model.locationId; // item owned
        }

    }
}